export function numToKor(num: number): string {
  let parsedNum = parseInt((num + '').replace(/[^0-9]/g, ''), 10) + '';
  if (parsedNum === '0') {
    return '영';
  }

  const digits = ['영', '일', '이', '삼', '사', '오', '육', '칠', '팔', '구'];
  const units = ['', '만', '억', '조'];
  const smallUnits = ['천', '백', '십', ''];

  const result: string[] = [];

  const unitCnt = Math.ceil(parsedNum.length / 4);
  parsedNum = parsedNum.padStart(unitCnt * 4, '0');

  const regex = /[\w\W]{4}/g;
  const array = parsedNum.match(regex);

  if (array) {
    for (let i = array?.length - 1, unitCnt = 0; i >= 0; i--, unitCnt++) {
      const korValue = _makeKor(array[i]);
      if (korValue === '') continue;

      result.unshift(korValue + units[unitCnt]);
    }
  }

  function _makeKor(text: string): string {
    let str = '';
    for (let i = 0; i < text.length; i++) {
      const num = parseInt(text[i]);
      if (num === 0) continue;
      str += digits[num] + smallUnits[i];
    }
    return str;
  }

  return result.join('');
}
